import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import { 
  SearchFilters
} from "../../../types/v1_schemas";
import FilterCheckbox from "./FilterCheckbox";
import {
  getLookupOptions,
  optionWithId
} from "../../../utils/lookup";
import { toggleItemInFilterList } from "../../../utils/filters/shared";

type AgeGroupInputProps = {
  legend: string;
  compact?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};


function AgeGroupInput({
  legend,
  compact = false,
  filters,
  setFilters,
}: AgeGroupInputProps) {
  const { t } = useTranslation();

  const [ageOptions, _setAgeOptions] = useState(() => getLookupOptions("age"));

  const setAgeFilter = (age: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "age group",
      filter_type: "age group",
      filter_value: age.lineageText,
    });
  
    setFilters({
      ...filters,
      patientAgeGroupIds: toggleItemInFilterList(
        filters.patientAgeGroupIds as any[],
        age.id.toString()
      ) as [] | undefined,
    });

  };


  return (
      <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
        {ageOptions.filter(function(obj){return obj.lineageText !== "Unknown"}
        ).map((option) => (
          <FilterCheckbox
            name={`age-${compact ? "desktop" : "mobile"}`}
            value={option.id.toString()}
            label={t(`${option.translate}`)}
            selectedFilterValues={filters.patientAgeGroupIds ?? []}
            onChange={() => setAgeFilter(option)}
            key={option.id.toString()}
          />
        ))}
      </Fieldset>
  );
}

export default AgeGroupInput;
